import customers from './components/customer/reducer'
import customerPackages from './components/customer-package/reducer'
import nationalities from './components/nationality/reducer'

const customer = { nationalities, customerPackages, customers }

export {
  customer
}